import { IApplicationState } from 'app/types/types';
import { connect } from 'react-redux';
import { IMoveToHOCProps } from './types';
import { IMoveToEvents, IMoveToFields } from '../../components/MoveTo/types';
import { MoveTo } from '../../components/MoveTo/MoveTo';
import {
    getAuthUserPlatformType
} from '../../../../../../../../store/model/authUser/selectors/getAuthUserPlatformType';
import { TTabKey } from '../../../../../../dialogs/openBoards/store/types';
import { getAuthUser } from '../../../../../../../../store/model/authUser/selectors/getAuthUser';
import { CommonAuthManager } from '../../../../../../../../helper/authorisation/common/CommonAuthManager';
import { onLoadItems } from './events/onLoadItems';
import { onMoveTo } from './events/onMoveTo';
import { getBoardPermissions } from '../../../../../../../../store/model/selectors/getBoardPermissions';
import { getOpenBoardsTabs } from '../../../../../../dialogs/openBoards/store/constants';

const mapStateToProps = (
    state: IApplicationState,
    { boardId }: IMoveToHOCProps
): IMoveToFields => {
    const boardPermissions = getBoardPermissions(state, boardId);
    const platformType = getAuthUserPlatformType(state);

    let planBlocker = null;
    let scopesBlocker = null;
    const tab = getOpenBoardsTabs(state)[TTabKey.sharedDrives];
    const allow = tab.allow;
    if (allow) {
        const user = getAuthUser(state);
        if (
            user &&
            !user[allow] &&
            tab.showPlanBlocker
        ) {
            planBlocker = tab.showPlanBlocker[platformType];
        }
    }

    if (!planBlocker && tab.scopes) {
        const scopes = tab.scopes[platformType];
        if (scopes &&
            !CommonAuthManager.checkOneOfScopes(scopes.success)
        ) {
            scopesBlocker = scopes.emptyDummyId;
        }
    }
    return {
        isShow: boardPermissions && boardPermissions.authPermissions && boardPermissions.authPermissions.allowMoveThisBoard,
        planBlocker,
        scopesBlocker,
    };
};

const mapDispatchToProps = (
    dispatch: any,
    { boardId }: IMoveToHOCProps
): IMoveToEvents => {
    return {
        onLoadItems: () => dispatch(onLoadItems(boardId)),
        onMoveTo: (driveId) => dispatch(onMoveTo(boardId, driveId)),
    }
};

export const MoveToHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(MoveTo);

MoveToHOC.displayName = 'MoveToHOC';
